module.exports = __webpack_public_path__ + "assets/media/navigations-close.def9dcfb.svg";